import { CaseReviewsFilterOptions } from '../../enums/filters-and-searchs/case.reviews.filter.options';

export const CaseReviewsFilterOptionDetails = new Map<number, string>([
    [CaseReviewsFilterOptions.None, 'None'],
    [CaseReviewsFilterOptions.Deleted, 'Deleted Case Reviews']
]);
